import React from "react";

function ReservationActionsBar(props) {
    return (
        <div className="actionsbar show">

            <div className="row buttons-row">
                <button className={props.btnClassName} onClick={props.buttonAction} data-qa="reservation-submit-btn">
                    {props.buttonName}
                </button>
            </div>
        </div>
    );
}

export default ReservationActionsBar;
